module.exports = "../dist/frontend/icons/symbols/cards/gold.svg?64f76dc6540e852a2f615b018ce66658";